<template>
  <div class="flow-item d-f-column">
    <img :src="item.path" :alt="meeting_title" />
    {{ item.text }}
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
import { meeting_title } from '@/utils/constant'
import { IFlowChar } from '@/typings/home'

export default defineComponent({
  props: {
    item: {
      type: Object as PropType<IFlowChar>
    }
  },
  setup() {
    return {
      meeting_title
    }
  }
})
</script>

<style scoped lang="scss">
.flow-item {
  width: 90px;
  color: #333;
  font-size: 18px;
  img {
    user-select: none;
    width: 90px;
    margin-bottom: 20px;
  }
}
</style>
